import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslationService } from '../services/translation.service';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, FormsModule,RouterModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
  currentLanguage: string = 'es';
  menuOpen = false;
  hasRole = false;
  userId: number | null = null; // Propiedad para almacenar el ID del usuario
  private destroy$ = new Subject<void>();

  constructor(
    public translationService: TranslationService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    // Suscripción al idioma
    this.translationService.currentLanguage$
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => (this.currentLanguage = lang));

    // Suscripción al rol del usuario
    this.authService.userRole$
      .pipe(takeUntil(this.destroy$))
      .subscribe(role => {
        this.hasRole = !!role;
      });

    // Obtén el ID del usuario desde AuthService
    this.authService.info().subscribe({
      next: (data) => {
        this.userId = data.id; // Guarda el ID del usuario
      },
      error: (error) => {
        console.error('Error al obtener el ID del usuario:', error);
      }
    });
  }

  changeLanguage(event: Event) {
    const selectedLanguage = (event.target as HTMLSelectElement).value;
    this.translationService.setLanguage(selectedLanguage);
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  logout() {
    this.authService.logout().subscribe(() => {
      this.hasRole = false; // Limpiar rol
      this.router.navigate(['/login']); // Redirigir correctamente
    });
  }

  navigateToFormulario() {
    this.router.navigate(['/registrodeobra']);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
